var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { autocomplete: "off", "lazy-validation": "" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          !_vm.isMobile
            ? _c("h1", { staticClass: "wizard-header-text" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ])
            : _vm._e(),
          _vm.debug
            ? _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      return _vm.validate()
                    }
                  }
                },
                [_vm._v("Validovat")]
              )
            : _vm._e(),
          _vm.debug
            ? _c("debug-control", {
                attrs: {
                  value: [
                    "validationObjectResult",
                    "formValid",
                    "somethingIsLoading",
                    "somethingGetDirty",
                    "currentControl"
                  ],
                  parent: this
                },
                on: { click: _vm.log }
              })
            : _vm._e(),
          _c(
            "v-row",
            { staticClass: "card", attrs: { "no-gutters": "" } },
            [
              _c("span", { staticClass: "gs100" }, [
                _vm._v(
                  " Vyberte si typ produktu a frekvenciu splácania, ktoré vám najviac vyhovujú. "
                )
              ]),
              _c(
                "v-btn-toggle",
                {
                  staticClass:
                    "button-group row no-gutters button-group-select mr-0 ml-0 produkt-group",
                  class: {
                    readonly: _vm.readonly || _vm.isDisabled || _vm.isLoading
                  },
                  attrs: {
                    group: "",
                    multiple: "",
                    rules: [_vm.validate],
                    max: 4
                  },
                  on: {
                    change: function(val) {
                      this$1.setDirty(true)
                      _vm.update(val)
                    }
                  },
                  model: {
                    value: _vm.l_value,
                    callback: function($$v) {
                      _vm.l_value = $$v
                    },
                    expression: "l_value"
                  }
                },
                [
                  _c(
                    "v-col",
                    {
                      staticStyle: { padding: "0px !important" },
                      attrs: { cols: "12" }
                    },
                    _vm._l(_vm.categories, function(item, index) {
                      return _c(
                        "v-row",
                        {
                          key: index,
                          staticClass: "mt-6 ml-0 mr-0",
                          attrs: { "no-gutters": "" }
                        },
                        [
                          index != 0 && index != _vm.categories.length
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "mb-6",
                                  attrs: {
                                    cols: "12",
                                    xl: "12",
                                    lg: "12",
                                    md: "12"
                                  }
                                },
                                [_c("v-divider")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                xl: "12",
                                lg: "12",
                                md: "12"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "8" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-3",
                                          staticStyle: {
                                            "font-size": "18px",
                                            "font-weight": "700"
                                          }
                                        },
                                        [
                                          _vm._v(" " + _vm._s(item.key) + " "),
                                          _vm.isMobile
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass: "btn-help ml-2",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openMobileProduktInfo(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" mdi-help-circle ")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm.isOLFSInArray(item)
                                    ? _c(
                                        "v-col",
                                        {
                                          style: !_vm.isMobile
                                            ? "text-align:end"
                                            : "padding-top: 0px !important; padding-bottom: 12px !important",
                                          attrs: { cols: "12", md: "4" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "produkt_porovnanie_balikov",
                                              attrs: { outlined: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openPorovnanieBalikovDialog()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "17" } },
                                                [
                                                  _vm._v(
                                                    "$produkt_porovnanie_balikov"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" Porovnanie balíkov")
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          !_vm.isMobile
                            ? _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xl: "12",
                                    lg: "12",
                                    md: "12"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mb-3 gs100",
                                      staticStyle: { "font-size": "16px" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "white-space": "pre-line"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.popis))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._l(item.children, function(button, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                staticClass:
                                  "pl-0 pr-0 button-group-select--btn",
                                attrs: {
                                  cols: "12",
                                  xl: "4",
                                  lg: "4",
                                  md: "6",
                                  sm: "12"
                                }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    class: [
                                      "pa-0",
                                      "no-disabled",
                                      {
                                        "premium-btn":
                                          button.is_enabled != null &&
                                          !button.is_enabled
                                      }
                                    ],
                                    staticStyle: { "font-weight": "700" },
                                    attrs: {
                                      value: button.valueMember,
                                      disabled:
                                        _vm.isDisabled ||
                                        (button.is_enabled != null &&
                                          !button.is_enabled),
                                      outlined: ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(button.displayMember) + " "
                                    ),
                                    !_vm.isMobile && button.popis
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              left: "",
                                              "max-width": "350"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-help ml-2",
                                                              staticStyle: {
                                                                "pointer-events":
                                                                  "auto",
                                                                cursor:
                                                                  "default"
                                                              }
                                                            },
                                                            "v-icon",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " mdi-help-circle "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(button.popis))
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm.isOLFSInArray(item) && _vm.selectedOLFS
                            ? _c(
                                "v-col",
                                { attrs: { xl: "12", lg: "12", md: "12" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      ref: "olfsForm",
                                      refInFor: true,
                                      attrs: { autocomplete: "off" },
                                      model: {
                                        value: _vm.olfsFormValid,
                                        callback: function($$v) {
                                          _vm.olfsFormValid = $$v
                                        },
                                        expression: "olfsFormValid"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                xl: "12",
                                                lg: "12",
                                                md: "12"
                                              }
                                            },
                                            [_c("v-divider")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                xs: "12",
                                                sm: "12",
                                                md: "12"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xl: "12",
                                                        lg: "12",
                                                        md: "12"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "mb-3",
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                            "font-weight": "700"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Doplňte informácie pre Operatívny leasing "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "3",
                                                        sm: "12"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            "no-gutters": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "f12 gs100"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Značka a model"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass: "bold",
                                                          attrs: {
                                                            "no-gutters": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass: "f16"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.znackaDisplay
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.modelDisplay
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm.isMobile
                                                        ? _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                "no-gutters": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "f12 gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefTooltip(
                                                                          _vm
                                                                            .$refs
                                                                            .modely_verzie
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c("dynamic-combo", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: false,
                                                            expression: "false"
                                                          }
                                                        ],
                                                        key:
                                                          "liw_filip__wiz_predmet__cb_znacky",
                                                        ref: "znacka",
                                                        refInFor: true,
                                                        attrs: {
                                                          "data-id":
                                                            "liw_filip__wiz_predmet__cb_znacky",
                                                          cisloPredmetu:
                                                            _vm.pripad
                                                              .cisloPredmetu
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.onZnackaChanged
                                                        }
                                                      }),
                                                      _c("dynamic-combo", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: false,
                                                            expression: "false"
                                                          }
                                                        ],
                                                        key:
                                                          "liw_filip__wiz_predmet__cb_modely",
                                                        ref: "modely",
                                                        refInFor: true,
                                                        attrs: {
                                                          "data-id":
                                                            "liw_filip__wiz_predmet__cb_modely",
                                                          cisloPredmetu:
                                                            _vm.pripad
                                                              .cisloPredmetu
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.onModelChanged
                                                        }
                                                      }),
                                                      _c("numeric-text-box", {
                                                        key:
                                                          "liw_filip__wiz_produkt__txt_poplatok_di_zakl",
                                                        ref: "poplatok_di_zakl",
                                                        refInFor: true,
                                                        attrs: {
                                                          "data-id":
                                                            "liw_filip__wiz_produkt__txt_poplatok_di_zakl",
                                                          cisloPredmetu:
                                                            _vm.pripad
                                                              .cisloPredmetu,
                                                          hideLabel: "",
                                                          "hide-details": "",
                                                          "hide-tooltip": ""
                                                        }
                                                      }),
                                                      _c("numeric-text-box", {
                                                        key:
                                                          "liw_filip__wiz_produkt__txt_poplatok_di_s_dph",
                                                        ref: "poplatok_di_dph",
                                                        refInFor: true,
                                                        attrs: {
                                                          "data-id":
                                                            "liw_filip__wiz_produkt__txt_poplatok_di_s_dph",
                                                          cisloPredmetu:
                                                            _vm.pripad
                                                              .cisloPredmetu,
                                                          hideLabel: "",
                                                          "hide-details": "",
                                                          "hide-tooltip": ""
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticStyle: {
                                                        padding: "12px 5px"
                                                      },
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "12",
                                                        md: "6"
                                                      }
                                                    },
                                                    [
                                                      _c("dynamic-combo", {
                                                        key:
                                                          "liw_filip__wiz_predmet__cb_modely_verzie",
                                                        ref: "modely_verzie",
                                                        refInFor: true,
                                                        attrs: {
                                                          clearable: "",
                                                          "data-id":
                                                            "liw_filip__wiz_predmet__cb_modely_verzie",
                                                          cisloPredmetu:
                                                            _vm.pripad
                                                              .cisloPredmetu,
                                                          "fulltext-filter": "",
                                                          "hide-tooltip": ""
                                                        },
                                                        on: {
                                                          valueChanged:
                                                            _vm.onModelyVerzieValueChanged
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.isMobile
                                                    ? _c(
                                                        "v-col",
                                                        {
                                                          staticStyle: {
                                                            "align-self":
                                                              "center",
                                                            "margin-top":
                                                              "-12px",
                                                            "padding-left":
                                                              "0px"
                                                          }
                                                        },
                                                        [
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .modely_verzie
                                                          )
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                    "max-width":
                                                                      "350"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "btn-help text-body-2",
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "activator"
                                                                                  },
                                                                                  slot:
                                                                                    "activator"
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-help-circle"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.getRefTooltip(
                                                                            _vm
                                                                              .$refs
                                                                              .modely_verzie
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                {
                                                  class: !_vm.isMobile
                                                    ? "mx-0"
                                                    : ""
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "12" } },
                                                    [
                                                      !_vm.isMobile
                                                        ? _c(
                                                            "v-row",
                                                            [
                                                              _c("v-col", {
                                                                attrs: {
                                                                  cols: "12",
                                                                  md: "3"
                                                                }
                                                              }),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "f16 bold",
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "3"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Cena bez DPH"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "f16 ",
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "4"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "bold"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Cena vratane DPH "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100 text-required"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .cennikova_cena_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .cennikova_cena_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .cennikova_cena_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .cennikova_cena_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .cennikova_cena_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_cena_noveho_vozidla_zakl",
                                                                  ref:
                                                                    "cennikova_cena_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_cena_noveho_vozidla_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    rules: [
                                                                      _vm.cenaRule
                                                                    ],
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onCennikovaCenaZaklChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_cena_noveho_vozidla_s_dph",
                                                                  ref:
                                                                    "cennikova_cena_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_cena_noveho_vozidla_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    rules: [
                                                                      _vm.cenaRule
                                                                    ],
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onCennikovaCenaSDPHChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                xl: "12",
                                                                lg: "12",
                                                                md: "12"
                                                              }
                                                            },
                                                            [_c("v-divider")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .cena_prislusenstva_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .cena_prislusenstva_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .cena_prislusenstva_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .cena_prislusenstva_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .cena_prislusenstva_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_cena_prislusenstva_zakl",
                                                                  ref:
                                                                    "cena_prislusenstva_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_cena_prislusenstva_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onCenaPrislusenstvaZaklChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_cena_prislusenstva_s_dph",
                                                                  ref:
                                                                    "cena_prislusenstva_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_cena_prislusenstva_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onCenaPrislusenstvaSDPHChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                xl: "12",
                                                                lg: "12",
                                                                md: "12"
                                                              }
                                                            },
                                                            [_c("v-divider")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .zlava_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .zlava_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .zlava_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs.zlava_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .zlava_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_zlava_zakl",
                                                                  ref:
                                                                    "zlava_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_zlava_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onZlavaZalkChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_zlava_s_dph",
                                                                  ref:
                                                                    "zlava_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_zlava_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onZlavaSDPHChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_zlava_perc",
                                                                  ref:
                                                                    "zlava_perc",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_zlava_perc",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "%",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Zľava"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onZlavaPercChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                xl: "12",
                                                                lg: "12",
                                                                md: "12"
                                                              }
                                                            },
                                                            [_c("v-divider")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .dodat_vybava_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .dodat_vybava_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .dodat_vybava_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .dodat_vybava_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .dodat_vybava_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_dod_vybava_zakl",
                                                                  ref:
                                                                    "dodat_vybava_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_dod_vybava_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onDodatVybavaZaklChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_dod_vybava_s_dph",
                                                                  ref:
                                                                    "dodat_vybava_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_dod_vybava_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    valueChanged: function() {
                                                                      return _vm.onDodatVybavaSDPHChanged()
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                xl: "12",
                                                                lg: "12",
                                                                md: "12"
                                                              }
                                                            },
                                                            [_c("v-divider")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .fakturovana_cena_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .fakturovana_cena_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2 ml-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .fakturovana_cena_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .fakturovana_cena_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .fakturovana_cena_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_fakturovana_cena_zakl",
                                                                  ref:
                                                                    "fakturovana_cena_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_fakturovana_cena_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_fakturovana_cena_s_dph",
                                                                  ref:
                                                                    "fakturovana_cena_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_fakturovana_cena_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                xl: "12",
                                                                lg: "12",
                                                                md: "12"
                                                              }
                                                            },
                                                            [_c("v-divider")],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticStyle: {
                                                                "align-self":
                                                                  "center"
                                                              },
                                                              attrs: {
                                                                cols: "12",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "gs100"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getRefLabel(
                                                                          _vm
                                                                            .$refs
                                                                            .kupna_cena_zakl
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              !!_vm.getRefTooltip(
                                                                _vm.$refs
                                                                  .kupna_cena_zakl
                                                              ) && !_vm.isMobile
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                        "max-width":
                                                                          "350"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-help text-body-2 ml-2",
                                                                                      attrs: {
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      slot:
                                                                                        "activator"
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-help-circle"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getRefTooltip(
                                                                                  _vm
                                                                                    .$refs
                                                                                    .kupna_cena_zakl
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          !!_vm.getRefTooltip(
                                                            _vm.$refs
                                                              .kupna_cena_zakl
                                                          ) && _vm.isMobile
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    "no-gutters":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "f12 gs100"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getRefTooltip(
                                                                              _vm
                                                                                .$refs
                                                                                .kupna_cena_zakl
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_kupna_cena_zakl",
                                                                  ref:
                                                                    "kupna_cena_zakl",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_kupna_cena_zakl",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena bez DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                                md: "3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "numeric-text-box",
                                                                {
                                                                  key:
                                                                    "liw_filip__wiz_produkt__txt_kupna_cena_s_dph",
                                                                  ref:
                                                                    "kupna_cena_s_dph",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    "data-id":
                                                                      "liw_filip__wiz_produkt__txt_kupna_cena_s_dph",
                                                                    cisloPredmetu:
                                                                      _vm.pripad
                                                                        .cisloPredmetu,
                                                                    suffix: "€",
                                                                    decimalPlaces: 2,
                                                                    textRight: false,
                                                                    hideLabel: !_vm.isMobile,
                                                                    customLabel: _vm.isMobile
                                                                      ? "Cena vratane DPH"
                                                                      : null,
                                                                    placeholder:
                                                                      "0,00",
                                                                    "hide-details":
                                                                      "",
                                                                    "hide-tooltip":
                                                                      "",
                                                                    replaceNull:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          item.info
                            ? _c(
                                "v-col",
                                { attrs: { xl: "12", lg: "12", md: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mt-3 toggle-info-text",
                                      staticStyle: { "font-size": "16px" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "white-space": "pre-line"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.info))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "896" },
          model: {
            value: _vm.porovnanieBalikovDialog,
            callback: function($$v) {
              _vm.porovnanieBalikovDialog = $$v
            },
            expression: "porovnanieBalikovDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "dialog-card" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex justify-space-between dialog-title-close"
                },
                [
                  _c("span", [_vm._v(" Porovnanie balíkov ")]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.closePorovnanieBalikov()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "gs100" },
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mx-0" },
                            _vm._l(_vm.porovnanieBalikov, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-col",
                                { key: index, attrs: { cols: "12", md: 4 } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticStyle: { gap: "8px" },
                                      attrs: { "no-gutters": "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "bold",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "f18 white100" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item[0].display_member
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._l(item, function(row, rowIndex) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: rowIndex,
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "btn-help porovnanie-balikov-icon",
                                                attrs: { size: "16px" }
                                              },
                                              [_vm._v(" $check_circle ")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                " " + _vm._s(row.sluzba) + " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }